const defaultErrorMessage =
  'Erro inesperado. Verifique sua internet e tente novamente.';

export default class ResponseError {
  message = '';
  display?: string;
  displayDetails = {} as DisplayDetails;
  status = 0;
  code?: string;

  constructor({ response }: any) {
    this.message = response?.data.message || defaultErrorMessage;
    this.status = response?.status || 0;
    this.code = response?.data?.code || undefined;
    this.display = response?.data?.display || undefined;
    this.displayDetails = response?.data?.displayDetails || undefined;
  }
}
